import React from 'react';
import { getDataWithQueryString } from '../../../../../api/componentAPIs';
import CommonAccessibleTerminal from '../CommonAccessibleTerminal';
import { withUserProfile } from '../../../../../userProfile/userProfileContext';
import Events from '../../../../../utilities/EventEmitter';
import appConstants from '../../../../../appConstants';

class AccessibleTerminal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      accessibleTerminalData: null,
      isDataLoaded: false,
      showErrorMessage: appConstants.GRID_STATUS.LOADING
    };
  }

  componentDidMount() {
    this._isComponentMounted = true;
    Events.on('RefreshAccessibleTerminals', this.loadAccessibleTerminalsData);
    this.loadAccessibleTerminalsData();
  }

  componentWillUnmount() {
    this._isComponentMounted = false;
    Events.off('RefreshAccessibleTerminals', this.loadAccessibleTerminalsData);
  }

  loadAccessibleTerminalsData = () => {
    getDataWithQueryString(
      'GetAccessibleTerminal',
      `terminalCode=${this.props.userData.userProfile.terminal.code}`
    ).then(
      (response) => {
        if (!this._isComponentMounted) {
          return;
        }
        if (response?.status >= 200 && response.status < 400) {
          this.setState({
            accessibleTerminalData: response.data,
            isDataLoaded: true,
            showErrorMessage: appConstants.GRID_STATUS.SUCCESS
          });
          return;
        }
        this.setState({
          accessibleTerminalData: [],
          isDataLoaded: true,
          showErrorMessage: appConstants.GRID_STATUS.ERROR
        });
      },
      (_error) => {
        if (!this._isComponentMounted) {
          return;
        }
        this.setState({
          accessibleTerminalData: [],
          isDataLoaded: true,
          showErrorMessage: appConstants.GRID_STATUS.ERROR
        });
      }
    );
  };

  render() {
    const { accessibleTerminalData, isDataLoaded, showErrorMessage } = this.state;
    return (
      <CommonAccessibleTerminal
        title="Pickup Accessible Terminals"
        description="Move a pickup from current terminal to another accessible terminal."
        accessibleTerminalData={accessibleTerminalData}
        isDataLoaded={isDataLoaded}
        updateAPI="UpdateAccessibleTerminal"
        showErrorMessage={showErrorMessage}
      />
    );
  }
}
export default withUserProfile(AccessibleTerminal);
